import { render } from "./SystemHealth.vue?vue&type=template&id=344dbc54"
import script from "./SystemHealth.vue?vue&type=script&lang=js"
export * from "./SystemHealth.vue?vue&type=script&lang=js"
script.render = render

export default script